<script setup>
import ChatButton from '@/components/ui/chat/ChatButton'
import { computed } from 'vue'
import DJIcon from '~/components/ui/icon/Icon.vue'
import { IconSealCheck } from '~/components/ui/icon/icons'
import { DESKTOP } from '~/constant/common'
import DJButton from '~/components/ui/button/Button.vue'
import { useGeneralInfoStore } from '~/store/pinia/generalInfo'

const props = defineProps({
  designer: {
    type: Object,
    required: true,
  },
  enquiryID: {
    type: Number,
    required: true,
  },
  tripID: {
    type: Number,
    required: true,
  },
})
const generalStore = useGeneralInfoStore()

const windowWidth = computed(() => generalStore.generalData.windowWidth)
const isDesktop = computed(() => windowWidth.value >= DESKTOP)
const firstNameDesigner = computed(() => {
  return props.designer?.first_name || ''
})
</script>

<template>
  <div v-if="isDesktop" class="flex flex-column items-center grid-gap-16 pa-16 bd-1 bd-gray-300-brand sd-1 br-10">
    <div class="pa-8 white bg-brand-900 flex justify-center items-center br-999 bd-3 bd-brand-500">
      <DJIcon>
        <IconSealCheck />
      </DJIcon>
    </div>
    <span class="text-lg-sb tc">
      {{ `Is there anything you'd like ${firstNameDesigner} to change to make this trip perfect for you?` }}
    </span>
    <ChatButton
      id="button-bookable-trip-plan-request-change"
      class="wp-100"
      v-if="designer?.id && enquiryID && tripID"
      type="enquiry-3w"
      :expertID="parseInt(designer?.id)"
      :enquiryID="parseInt(enquiryID)"
      :followTripID="parseInt(tripID)"
    >
      <DJButton class="wp-100"> Chat with Us </DJButton>
    </ChatButton>
  </div>
</template>
